import { createEnumParam, useQueryParam, withDefault } from "use-query-params";
import { QP_LAYOUT } from "./constants";

const LayoutParam = createEnumParam(["table", "grid"]);

export const useQPLayout = () => {
  return useQueryParam(QP_LAYOUT, withDefault(LayoutParam, "table"));
};
